var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.currentUser)?_c('LoginBar'):_c('AppointmentBar')}
var staticRenderFns = []

export { render, staticRenderFns }